(() => {
  function run(root) {
    root.querySelectorAll('script[data-theme-deferred]:not([data-executed])').forEach(source => {
      source.dataset.executed = 'true';
      const script = document.createElement('script');
      if (source.nonce) script.nonce = source.nonce;
      script.textContent = source.textContent;
      source.after(script);
    });
  }
  function sizeImages(root) {
    root.querySelectorAll('img[data-intrinsic-size]').forEach(image => {
      const size = () => {
        if (!Number(image.getAttribute('width')) && image.naturalWidth) {
          image.setAttribute('width', image.naturalWidth);
          image.setAttribute('height', image.naturalHeight);
        }
      };
      if (image.complete) size(); else image.addEventListener('load', size, {once: true});
    });
  }
  run(document);
  sizeImages(document);
  document.addEventListener('shopify:section:load', event => sizeImages(event.target));
  document.addEventListener('shopify:section:load', event => run(event.target));
})();
